import {
  alpha,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core/styles';

import { colors } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  sidemenuScroll: {
    overflowY: 'auto',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: '0.7em',
      marginRight: '15px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f162',
      /* background-color: white; */
      // marginTop: '18px',
      // marginBottom: '18px',
      // boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      // webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.5)',
      // outline: '3px solid slategrey',
      borderRadius: 180,
    },
  },
}));

export default useStyles;
